document.addEventListener("DOMContentLoaded", function() {
    const copyButtons = document.querySelectorAll('[data-copy-button]');

    copyButtons.forEach((element, index, elements) => {
        element.addEventListener("click", (event) => {
            const el = document.createElement('textarea');
            el.value = element.dataset.copyButton;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            alert('URL gekopieerd naar klembord!');
        });
    });
});

